import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getSvgVersion, getIsLoading, getCnt, getIsTennisLoading, getIsTennisEnabled,
} from '../../selectors/common';
import SVGProvider from '../../components/SVG/SVGProvider';
import { COLOMBIA_SKIN, SKIN } from '../../constants';
import { aGetInit, aGetInitTennis } from '../../reducers';
import Loader from '../../components/Loader';
import MainRouter from '../../MainRouter';
import { aLocationChanged } from '../../reducers/common';

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();


  const svgVersion = useSelector(getSvgVersion);
  const isLoadingStore = useSelector(getIsLoading);
  const isTennisLoading = useSelector(getIsTennisLoading);
  const cnt = useSelector(getCnt);
  const isTennisEnabled = useSelector(getIsTennisEnabled);

  const checkSession = (payload) => dispatch(aGetInit(payload));
  const initTennis = (payload) => dispatch(aGetInitTennis(payload));

  useEffect(() => {
    dispatch(aLocationChanged(location.pathname));
  },[dispatch, location.pathname]);

  useEffect(() => {
    checkSession({ location, navigate });
    if (SKIN !== COLOMBIA_SKIN) initTennis();
    // eslint-disable-next-line
  }, []);

  const getIsLoadingContent = () => location.pathname.includes('tennis') && isTennisEnabled
    ? (isLoadingStore === true || isTennisLoading === true)
    : (isLoadingStore === true);
  
  return (
    <div className="app">
      <SVGProvider
        svgVersion={svgVersion}
        cnt={cnt}
      >
        {getIsLoadingContent() ?
          <Loader /> :
          <MainRouter />}
      </SVGProvider>
    </div>
  );
};

export default App;
